export default "__VITE_ASSET__e095d978__"